<script lang="ts">
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

import IconComponent from '@/components/atoms/IconComponent.vue'

export type SocialLink = {
  id?: string
  social: string
  url: string
}

export default defineComponent({
  name: 'SocialLinks',
  components: {
    IconComponent
  },
  props: {
    align: { type: String as PropType<'start'|'end'|'center'>, default: 'start' },
    links: { type: Array as PropType<SocialLink[]>, default: () => [] },
    linkClass: { type: String, default: undefined }
  }
})
</script>

<template>
  <nav v-if="links?.length">
    <ul
      class="flex gap-3"
      :class="{
        'justify-start': align === 'start',
        'justify-end': align === 'end',
        'justify-center': align === 'center'
      }"
    >
      <li v-for="link, i in links" :key="link.id || i" class="social overflow-hidden">
        <a
          class="inline-block opacity-75"
          :class="linkClass"
          :href="link.url"
          target="_blank"
          rel="nofollow noopener"
        >
          <IconComponent class="w-6" :icon="link.social" />
        </a>
      </li>
    </ul>
  </nav>
</template>

<style lang="scss" scoped>
a {
  @include hover {
    transition: opacity var(--transition-duration);

    &:hover {
      opacity: 1;
    }
  }
}
</style>
